import parsePhoneNumber from 'libphonenumber-js'

import {getTopAddress, getBottomAddress} from '../utils'


export function createVenueInfoWindow(venue) {
  const {
    tags,
    name,
    image,
    address,
    phoneNumber,
    imageDerivatives,
    externalImageUrl
  } = venue.attributes

  const top = getTopAddress(address)
  const bottom = getBottomAddress(address)

  // Create container element for the info window
  const container = document.createElement('div')
  container.id = 'map-info-window-content'
  container.className = 'map-venue-info-window'
  container.setAttribute('data-type', 'venue')
  container.setAttribute('data-id', venue.id)

  // Image container
  const imageContainer = document.createElement('div')
  imageContainer.className = 'image-container'

  const aspectRatioBox = document.createElement('div')
  aspectRatioBox.className = 'aspect-ratio-box'

const aspectRatioInside = document.createElement('div')
  aspectRatioInside.className = 'aspect-ratio-box-inside'

  const infoWindowImage = imageDerivatives.small || image || externalImageUrl
  if (infoWindowImage) {
    const img = document.createElement('img')
    img.className = 'image'
    img.src = infoWindowImage
    aspectRatioInside.appendChild(img)
  } else {
    aspectRatioInside.innerHTML = `
      <svg height="70" width="70" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path fill="#A9A9A9" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/>
      </svg>
    `
  }

  aspectRatioBox.appendChild(aspectRatioInside)
  imageContainer.appendChild(aspectRatioBox)
  container.appendChild(imageContainer)

  // Details container
  const detailsContainer = document.createElement('div')
  detailsContainer.className = 'details-container'

  const header = document.createElement('div')
  header.className = 'header'
  header.innerHTML = `<p>venue</p><h3>${name}</h3>`

  // Address container
  const addressContainer = document.createElement('div')
  addressContainer.className = 'section-container'

  const addressRows = document.createElement('div')
  addressRows.className = 'address-rows-container'
  addressRows.innerHTML = `<p class="address-row">${top}</p><p class="address-row">${bottom}</p>`

  addressContainer.appendChild(addressRows)
  detailsContainer.appendChild(header)
  detailsContainer.appendChild(addressContainer)

  // Phone number section
  if (phoneNumber) {
    const number = phoneNumber?.charAt(0) === '+' ? phoneNumber : '+1' + phoneNumber
    const parsed = parsePhoneNumber(number)
    if (parsed && parsed?.getURI() && parsed?.formatInternational()) {
      const phoneDiv = document.createElement('div')
      phoneDiv.className = 'section-container'
      phoneDiv.innerHTML = `<a id="phone-link" href="${parsed.getURI()}">${parsed.formatInternational()}</a>`
      detailsContainer.appendChild(phoneDiv)
    }
  }

  // Tags section
  if (tags.length > 0) {
    const tagsContainer = document.createElement('div')
    tagsContainer.className = 'tags-container'
    tagsContainer.textContent = tags.map(tag => `#${tag.toUpperCase()}`).join(' ')
    detailsContainer.appendChild(tagsContainer)
  }

  container.appendChild(detailsContainer)

  const infoWindow = new window.google.maps.InfoWindow({
    disableAutoPan: true,
  })

  infoWindow.setContent(container)

  return infoWindow
}


